
import { onMounted, ref, computed } from 'vue';
import { restaurant, categories } from '@/global/state/GlobalState';
import { storefront, StorefrontSection, StorefrontSectionType } from '@/global/state/StorefrontState';
import { useCategory } from '@/composables/useCategory'
import ProductModal from '@/components/modal/ProductModal.vue';
import CategoriesShow from '../categories/CategoriesShow.vue';
import AnnouncementSection from '@/components/storefront/sections/AnnouncementSection.vue';
import BannersSection from '@/components/storefront/sections/BannersSection.vue';
import CategoriesSection from '@/components/storefront/sections/CategoriesSection.vue';
import InfoSection from '@/components/storefront/sections/InfoSection.vue';
import FeaturedProductsSection from '@/components/storefront/sections/FeaturedProductsSection.vue';
import ImageTextSection from '@/components/storefront/sections/ImageTextSection.vue';
import MenuSection from '@/components/storefront/sections/MenuSection.vue';
import StoreCover from '@/components/storefront/StoreCover.vue';

const sectionComponents: Record<StorefrontSectionType, any> = {
  announcement: AnnouncementSection,
  banners: BannersSection,
  categories: CategoriesSection,
  info: InfoSection,
  featured_products: FeaturedProductsSection,
  image_text: ImageTextSection,
  menu: MenuSection,
}

const __default__ = {
  name: 'home-page',
  components: {
    ProductModal,
    CategoriesShow,
    StoreCover
  },
  setup() {
      const isProductModalOpen = ref<boolean>(false)
      const isCategoriesLoading = ref<boolean>(true)
      const selectedProduct = ref<any>({})
      const selectedCategory = ref<any>(null)

      const enabledSections = computed<StorefrontSection[]>(() =>
        storefront.value.sections.filter((section) => section.enabled && sectionComponents[section.type])
      )

      const setModalProduct = (product: any) => {
        selectedProduct.value = product
        isProductModalOpen.value = !isProductModalOpen.value
      }

      function toggleProductModal(isOpen: boolean){
        isProductModalOpen.value = isOpen
      }

      onMounted(() => {
        if(!categories.value){
          isCategoriesLoading.value = true
          const { listCategories, categories: categoryList } = useCategory()

          listCategories({ perPage: 100 }).then(() => {
              categories.value = categoryList.value
              isCategoriesLoading.value = false
          }).catch(err => {
              console.error(err)
              isCategoriesLoading.value = false
          })
        }
      })

      return {
        sectionComponents,
        enabledSections,
        storefront,
        isProductModalOpen,
        setModalProduct,
        toggleProductModal,
        isCategoriesLoading,
        restaurant,
        selectedProduct,
        selectedCategory,
      };
    },
};

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "499388b7": (_ctx.restaurant.restaurantDesignCustom?.secondaryColor ?? '#ccc')
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__